import {get, post} from "../utils/baseRequest";
import {buildApiUrl} from "./apiConfig";
import mockLogsData from "./mockLogsData.json";

export const archiveTrigger = async ({ tenantId, triggerId, triggerData }) => {

  await new Promise(resolve => setTimeout(resolve, 600));

  const response = {
    success: true,
    data: {
      triggerId: triggerId,
      status: "archived",
      archivedAt: new Date().toISOString()
    },
    message: "Trigger archived successfully"
  };

  return response;
};

export const createTrigger = async (triggerData) => {
  try {
    let payload;

    if(triggerData.description){
      payload = {
        tenantUuid: triggerData.tenantId,
        name: triggerData.name,
        description: triggerData.description
      };
    } else {
      payload = {
        tenantUuid: triggerData.tenantId,
        name: triggerData.name
      }
    }

    const response = await post(`https://kkippfzwqj.execute-api.us-east-1.amazonaws.com/v1/trigger/create`, payload);

    return {
      success: true,
      data: {
        trigger: {
          uuid: response.uuid,
          name: response.name,
          status: response.status,
          updatedAt: response.updatedAt,
          flowUuid: response.flowUuid,
          externalFlowId: response.externalFlowId,
          msgCode: response.msgCode,
          requestId: response.requestId
        }
      },
      message: 'Trigger created successfully'
    };
  } catch (error) {
    return {
      error: true,
      message: error.response.data.message,
      status: error.response.status,
      msgCode: error.response.data.msgCode,
      requestId: error.response.data.requestId
    };
  }
};

export const duplicateTrigger = async ({ tenantId, triggerId, triggerData }) => {
  await new Promise(resolve => setTimeout(resolve, 800));


  const newUuid = Math.random().toString(36).slice(2, 11);


  const duplicatedTrigger = {
    type: triggerData.type,
    createdBy: triggerData.createdBy,
    nodes: triggerData.nodesText,
    executions: triggerData.executions,
    status: triggerData.statusValue,
    description: triggerData.descriptionText,
    uuid: newUuid,
    name: `${triggerData.nameText} Copy`,
    lastUpdated: new Date().toISOString().split('T')[0],
    enrolled: "0",
  };

  const response = {
    success: true,
    data: {
      trigger: duplicatedTrigger
    },
    message: "Trigger duplicated successfully"
  };

  return response;
};

export const getTriggerById = async ({ tenantId, triggerId }) => {
  try {
    const url = `/v1/trigger/${triggerId}`;
    const response = await get(buildApiUrl(url));

    if (response) {
      const trigger = {
        ...response,
        ...response.data,
        uuid: response.workflow?.workflowCatalogUuid || response.data?.uuid || response.data?.id || response.uuid || response.id,
        id: response.workflow?.workflowCatalogUuid || response.data?.id || response.data?.uuid || response.id || response.uuid,
        name: response.workflow?.name || response.data?.name || response.name,
        description: response.workflow?.description || response.data?.description || response.description,
        flowUuid: response.data?.flowUuid || response.flow?.uuid || response.flowUuid,
        externalFlowId: response.data?.externalFlowId || response.flow?.externalFlowId || response.externalFlowId
      };
      return { success: true, data: trigger };
    }
    return { success: false, message: "Trigger not found" };
  } catch (error) {
    console.error('Error in getTriggerById:', error);
    return { success: false, message: "Error fetching trigger" };
  }
};

export const listTriggerLogs = async ({ tenantId, page = 1, pageSize = 10 }) => {
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const response = {
    success: mockLogsData.success,
    data: mockLogsData.data,
    message: mockLogsData.message
  };

  return response;
};

export const listTriggers = async ({ tenantId, page = 1, pageSize = 15 }) => {
  const body = { page, pageSize };
  const response = await post(buildApiUrl(`/v1/trigger/list`), body);
  if (response && response.msgCode === "triggers_listed_successfully") {
    return {
      success: true,
      data: {
        triggers: response.triggers.map(trigger => ({
          ...trigger.workflow,
          uuid: trigger.workflow.workflowCatalogUuid,
          flowUuid: trigger.flow.uuid,
          externalFlowId: trigger.flow.externalFlowId
        })),
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          totalItems: response.totalItems,
          itemsPerPage: response.perPage
        }
      },
      message: "Triggers retrieved successfully"
    };
  }

  return {
    success: false,
    data: { triggers: [], pagination: {} },
    message: "Error retrieving triggers"
  };
};

export const updateTrigger = async (triggerData) => {
  try {
    const payload = {
      uuid: triggerData.uuid,
      name: triggerData.name,
      description: triggerData.description
    };

    const response = await post(buildApiUrl(`/v1/trigger/update`), payload);

    return {
      success: true,
      data: {
        trigger: {
          uuid: response.uuid,
          name: response.name,
          description: response.description,
          status: response.status,
          updatedAt: response.updatedAt,
          msgCode: response.msgCode,
          requestId: response.requestId
        }
      },
      message: 'Trigger updated successfully'
    };
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || error.message || 'Network error',
      status: error.response?.status || '',
      msgCode: error.response?.data?.msgCode,
      requestId: error.response?.data?.requestId
    };
  }
};